import AdminDahsboardPage from '@pages/admin/dashboard'
import AdminDoctorsPage from '@pages/admin/userManagement/doctors'
import AdminDoctorFormPage from '../pages/admin/userManagement/doctors/form'
import AdminDoctorDetailsPage from '@pages/admin/userManagement/doctors/details'
import AdminPatientsPage from '@pages/admin/userManagement/patients'
import AdminInstitutionsPage from '@pages/admin/userManagement/institutions'
import AdminInstitutionFormPage from '@pages/admin/userManagement/institutions/form'
import AdminInstitutionDetailsPage from '@pages/admin/userManagement/institutions/details'
import AdminCategoryManagementPage from '@pages/admin/categoryManagement'
import AdminMedicineManagementPage from '../pages/admin/medicineManagement'
import AdminLabTestsPage from '../pages/admin/labTests'
import AdminHelpAndSupportPage from '../commons/supportChat'
import AdminPlatformSettingPage from '@pages/admin/settings/platforms'
import AdminMarketingSettingsPage from '@pages/admin/settings/marketings'
import AdminSeoSettingsPage from '../pages/admin/settings/seo'
import AdminFaqsPage from '../pages/admin/settings/faqs'
import AdminAllPagesFormPage from '@pages/admin/allPages/form'

const routes = [
  {
    Component: AdminDahsboardPage,
    exact: true,
    index: true,
  },
  {
    Component: AdminDoctorsPage,
    exact: true,
    path: 'doctors',
  },
  {
    Component: AdminDoctorFormPage,
    exact: true,
    path: 'doctors/create',
  },
  {
    Component: AdminDoctorDetailsPage,
    exact: true,
    path: 'doctors/details/:slug',
  },
  {
    Component: AdminPatientsPage,
    exact: true,
    path: 'patients',
  },
  {
    Component: AdminInstitutionsPage,
    extact: true,
    path: 'institutions',
  },
  {
    Component: AdminInstitutionFormPage,
    exact: true,
    path: 'institutions/create',
  },
  {
    Component: AdminInstitutionDetailsPage,
    exact: true,
    path: 'institutions/details/:slug',
  },
  {
    Component: AdminCategoryManagementPage,
    exact: true,
    path: 'category-management',
  },
  {
    Component: AdminMedicineManagementPage,
    exact: true,
    path: 'medicine-management',
  },
  {
    Component: AdminLabTestsPage,
    exact: true,
    path: 'lab-tests',
  },
  {
    Component: AdminHelpAndSupportPage,
    exact: true,
    path: 'supports',
  },
  {
    Component: AdminAllPagesFormPage,
    exact: true,
    path: 'all-pages/:slug',
  },
  {
    Component: AdminPlatformSettingPage,
    exact: true,
    path: 'settings/platform-settings',
  },
  {
    Component: AdminMarketingSettingsPage,
    exact: true,
    path: 'settings/marketing-settings',
  },
  {
    Component: AdminSeoSettingsPage,
    exact: true,
    path: 'settings/seo-settings',
  },
  {
    Component: AdminFaqsPage,
    exact: true,
    path: 'settings/faqs',
  },
]

export default routes
